import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingNewsDetailMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * Parse URL to clean section URL parameters ("comparativas", "novedades"...)
   */
  _parseUrl = url => url.split('/').pop()

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {String} param.data.pageName
   * @param {String} param.data.tag
   * @param {String} param.data.make
   * @param {String} param.data.model
   * @param {Number} param.data.pageNumber
   * @param {Number} param.data.url
   */
  map({page, culture, data}) {
    const {pageName, tag, make, makeId, model, modelId, pageNumber, url, origin} = data
    const {TRACKING_TRANSLATIONS_BY_CULTURE} = this._config.get('tracking')
    const trackingData = {}

    switch (page) {
      case 'NEWS_DETAIL':
        if (pageName) trackingData.page_name = pageName
        if (tag) trackingData.page_category_level2 = tag
        if (make) trackingData.page_category_level3 = make
        if (makeId) trackingData.brand_id = Number(makeId)
        if (model) trackingData.page_category_level4 = model
        if (modelId) trackingData.model_id = Number(modelId)
        if (url) trackingData.news_url = this._parseUrl(url)
        if (origin) trackingData.hit_origin = origin

        break

      case 'NEWS_COMMENTS':
        if (page) trackingData.page_name = TRACKING_TRANSLATIONS_BY_CULTURE[culture].NEWS_DETAIL_COMMENTS_PAGE_NAME

        break
      case 'NEWS_DETAIL_GALLERY_IMAGE':
        if (pageNumber) trackingData.list_page_num = pageNumber
        break
      default:
        throw new Error(`No tracking data defined for page ${page}`)
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
